import { MinusIcon } from "@otomoro/components/icons/Minus"
import { PlusIcon } from "@otomoro/components/icons/Plus"
import { AppText } from "@otomoro/components/shared/AppText"
import { AppTitle } from "@otomoro/components/shared/AppTitle"
import { SanityImage } from "@otomoro/components/shared/SanityImage"
import { PortableText, PortableTextComponents } from "next-sanity"
import { styles, LocationVariants } from "./Location.css"
import { MouseEvent } from "react"

interface LocationTabProps extends LocationVariants {
  country: string
  city: string
  content: any
  thumbnail: any
  openIdx: number | null
  index: number
  toggleDetails: (e: MouseEvent, idx: number) => void
}

export const LocationTab: React.FC<LocationTabProps> = ({
  country,
  city,
  content,
  thumbnail,
  index,
  openIdx,
  toggleDetails
}) => {
  const contentComponent = {
		block: {
			normal: ({ children }: any) => (
				<AppText as="p" color="white" className="mt-[1.5rem] pb-2 md:max-w-[42ch]"
				>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

  const { locationTab } = styles()

  return (
    <details open={index === openIdx} onClick={(e) => toggleDetails(e, index)}>
      <summary className={locationTab()}>
        <AppTitle as="h3" variant="h3" textTransform="uppercase" color={index === openIdx ? 'mainPink' : 'white'}>
          {city}{(country && ' - ' + country)}
        </AppTitle>
        {index === openIdx ?
          <MinusIcon className="w-[1.4rem] h-[1.4rem]" active/>
        :
          <PlusIcon className="w-[1.4rem] h-[1.4rem]" theme="dark"/>
        }
      </summary>
      <div className="md:mx-auto w-full lg:w-fit">
        <SanityImage className="w-full object-cover h-full" figureClass="rounded-[0.56rem] overflow-hidden h-[22rem] md:max-w-[60vw] md:max-h-[36rem]"  image={thumbnail.image} alt={thumbnail.alt} sizes="100vw"/>
        <PortableText value={content} components={contentComponent}/>
      </div>
    </details>
  )
}
